import React from 'react';
import Timer from './Timer';
import {
    Box,
    Paper,
    Typography,
    Link,
    Divider,
    Alert,
    Button,
    Card,
    CardContent,
    Chip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import authService from './AuthService';
import { Phone as PhoneIcon, AccessTime as AccessTimeIcon } from '@mui/icons-material';

const formStyle = {
    margin: 'auto',
    padding: '10px',
    display: 'block',
    width: '90%',
    color: '#fff'
};

const labelStyle = {
    margin: '10px 0 5px 0',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '15px',
    color: '#333'
};

const inputStyle = {
    margin: '5px 0 10px 0',
    padding: '10px',
    border: '1px solid #bfbfbf',
    borderRadius: '30px',
    boxSizing: 'border-box',
    width: '100%'
};

const submitStyle = {
    margin: '10px 0 0 0',
    padding: '7px 10px',
    border: '1px solid #efffff',
    borderRadius: '30px',
    background: '#202020',
    width: '100%',
    fontSize: '15px',
    color: 'white',
    display: 'block',
    cursor: 'pointer'
};

const Field = React.forwardRef(({ label, type }, ref) => {
    return (
        <div>
            <label style={labelStyle}>{label}</label>
            <input ref={ref} type={type} style={inputStyle} />
        </div>
    );
});

const userid = authService.tokenInfo();

const Form = ({ onSubmit }) => {
    const usernameRef = React.useRef();
    const otpRef = React.useRef();
    const [otpButton, setOtpButton] = React.useState(true);
    const navigate = useNavigate();

    const resendWithOtp = e => {
        let send = {
            username: userid?.sub,
            otp: ""
        }

        const rest = authService.pathUrl("POST", "/auth/send-otp");
        authService.postAuth(rest, send)
            .then((result) => {
                setOtpButton(false)
                const msg = {
                    icon: 'success',
                    title: 'sms send',
                    text: result?.message
                }
                authService.showSwal(msg)
                setTimeout(() => {
                    navigate("/verify");
                    window.location.reload();
                }, 2000);
            }).catch(error => {
                console.log(error)
            });
    };

    const handleSubmit = e => {
        e.preventDefault();
        const data = {
            username: userid.sub,
            otp: otpRef.current.value
        };
        if (otpRef.current.value === "") {
            return;
        }

        onSubmit(data);
    };

    // Handle call support
    const handleCallSupport = () => {
        window.location.href = 'tel:+919730676527';
    };

    return (
        <form style={formStyle} onSubmit={handleSubmit}>
            {userid ?
                <Field ref={otpRef} label="Verification code:" type="text" />
                :
                <Field ref={usernameRef} label="Username:" type="text" />
            }

            {/* OTP Support Section */}
            <Card
                variant="outlined"
                sx={{
                    mt: 2,
                    mb: 2,
                    backgroundColor: '#f8f9fa',
                    borderColor: '#4CAF50',
                    borderWidth: 2,
                    borderRadius: 2
                }}
            >
                <CardContent sx={{ p: 2 }}>
                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                        <PhoneIcon color="success" />
                        <Typography variant="subtitle2" fontWeight="bold" color="success">
                            Need OTP help?
                        </Typography>
                        <Chip
                            label="24/7 Support"
                            size="small"
                            color="success"
                            icon={<AccessTimeIcon />}
                        />
                    </Box>

                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                        Didn't receive SMS? Call us immediately for OTP delivery
                    </Typography>

                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                            mt: 1,
                            p: 1,
                            backgroundColor: '#e8f5e9',
                            borderRadius: 1
                        }}
                    >
                        <Box display="flex" alignItems="center">
                            <PhoneIcon sx={{ color: '#2e7d32', mr: 1 }} />
                            <Typography variant="h6" fontWeight="bold" sx={{ color: '#2e7d32' }}>
                                +91 9730676527
                            </Typography>
                        </Box>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={handleCallSupport}
                            startIcon={<PhoneIcon />}
                            size="small"
                        >
                            Call Now
                        </Button>
                    </Box>
                </CardContent>
            </Card>

            {otpButton ? (
                <div>
                    <Timer setOtpButton={setOtpButton} />
                    <button style={submitStyle} type="submit">Submit</button>
                </div>
            ) : (
                <div>
                    <button style={submitStyle} type="button" onClick={() => resendWithOtp()}>Resend OTP</button>
                </div>
            )}
        </form>
    );
};

const VerifyBox = () => {
    const navigate = useNavigate();

    const handleSubmit = async (data) => {
        console.clear();

        const rest = authService.pathUrl("POST", "/auth/verify-otp");
        authService.postAuth(rest, data)
            .then((result) => {
                sessionStorage.setItem("token", result?.accessToken)
                const msg = {
                    icon: 'success',
                    title: 'Account verify',
                    text: 'OTP verified successfully.'
                }
                authService.showSwal(msg)

                const tokendata = authService.tokenInfo();
                setTimeout(() => {
                    if (tokendata.roles === "ADMIN")
                        navigate("/loginview");
                    else
                        navigate("/");
                    window.location.reload();
                }, 3000);

            }).catch(error => {
                console.log(error)
                const msg = {
                    icon: 'error',
                    title: 'Account Inactive',
                    text: 'Invalid or expired OTP Enter valid..'
                }
                authService.showSwal(msg)
            });
    };

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            }}
        >
            <Paper
                elevation={10}
                sx={{
                    p: 5,
                    width: 450,
                    maxWidth: '90%',
                    borderRadius: 5,
                    textAlign: 'center',
                    backgroundColor: '#ffffff',
                }}
            >
                <Typography variant="h4" fontWeight={600} gutterBottom sx={{ color: '#667eea' }}>
                    OTP Verification
                </Typography>
                <Typography variant="subtitle1" mb={3} color="textSecondary">
                    Enter the verification code sent to your registered mobile
                </Typography>

                <Form onSubmit={handleSubmit} />

                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 3 }}>
                    For immediate assistance, call +91 9730676527
                </Typography>
            </Paper>
        </Box>
    );
};

export default VerifyBox;